import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=d81620c2&scoped=true&"
var script = {}
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=d81620c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81620c2",
  null
  
)

export default component.exports